// extracted by mini-css-extract-plugin
export default {"container":"EditIndex_container__kNvnm","posts_box":"EditIndex_posts_box__hkFQI","progressContainer":"EditIndex_progressContainer__ltApq"};